import axios from "axios";

const AUTH_AXIOS = axios.create({
    baseURL: '/api/ident',
    timeout: 3000,
});

export {AUTH_AXIOS};